import React from "react";
import { useEffect, useState } from "react";
import livinglinen from "../Assets/LivingLinen/living-main.jpg";
import image1 from "../Assets/LivingLinen/1.jpg";
import image2 from "../Assets/LivingLinen/2.jpg";
import image3 from "../Assets/LivingLinen/3.jpg";
import image4 from "../Assets/LivingLinen/4.jpg";
import image5 from "../Assets/LivingLinen/5.jpg";
import image6 from "../Assets/LivingLinen/6.jpg";
import image7 from "../Assets/LivingLinen/7.jpg";
import image8 from "../Assets/LivingLinen/8.jpg";
import image9 from "../Assets/LivingLinen/18.jpg";
import image10 from "../Assets/LivingLinen/19.jpg";
import image11 from "../Assets/LivingLinen/20.jpg";
import image12 from "../Assets/LivingLinen/21.jpg";

import image18 from "../Assets/Basket/1.jpg";

function LivingLinen() {
  const [isAnimated, setIsAnimated] = useState(false);

  useEffect(() => {
    function handleScroll() {
      if (window.pageYOffset > 100) {
        setIsAnimated(true);
      }
    }
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <div className="clasification-main">
      <div className="collection-head">
        <img alt="Images" src={livinglinen}></img>
      </div>
      <div className="collection-body">
        <p className="collection-top-title">Throws</p>
        <div className="collection-img-flex">
          <img
            alt="Images"
            src={image1}
            className={`collection-img-flex-img ${isAnimated ? "animated" : ""
              }`}
            style={{ animationDelay: "0.5s" }}
          />
          <img
            alt="Images"
            src={image2}
            className={`collection-img-flex-img ${isAnimated ? "animated" : ""
              }`}
            style={{ animationDelay: "0.1s" }}
          />
          <img
            alt="Images"
            src={image3}
            className={`collection-img-flex-img ${isAnimated ? "animated" : ""
              }`}
            style={{ animationDelay: "1.5s" }}
          />
          <img
            alt="Images"
            src={image4}
            className={`collection-img-flex-img ${isAnimated ? "animated" : ""
              }`}
            style={{ animationDelay: "2s" }}
          />
        </div>
      </div>
      <div className="collection-body">
        <p className="collection-top-title">Cushions</p>
        <div className="collection-img-flex">
          <img
            alt="Images"
            src={image5}
            className={`collection-img-flex-img ${isAnimated ? "animated" : ""
              }`}
            style={{ animationDelay: "2.5s" }}
          />
          <img
            alt="Images"
            src={image6}
            className={`collection-img-flex-img ${isAnimated ? "animated" : ""
              }`}
            style={{ animationDelay: "3s" }}
          />
          <img
            alt="Images"
            src={image7}
            className={`collection-img-flex-img ${isAnimated ? "animated" : ""
              }`}
            style={{ animationDelay: "3.5s" }}
          />
          <img
            alt="Images"
            src={image8}
            className={`collection-img-flex-img ${isAnimated ? "animated" : ""
              }`}
            style={{ animationDelay: "4s" }}
          />
        </div>
      </div>

      {/* Stocking */}
      <div className="collection-body">
        <p className="collection-top-title">Stocking</p>
        <div className="collection-img-flex">
          <img
            alt="Images"
            src={image9}
            className={`collection-img-flex-img ${isAnimated ? "animated" : ""
              }`}
            style={{ animationDelay: "4.5s" }}
          />
          <img
            alt="Images"
            src={image10}
            className={`collection-img-flex-img ${isAnimated ? "animated" : ""
              }`}
            style={{ animationDelay: "5s" }}
          />
          <img
            alt="Images"
            src={image11}
            className={`collection-img-flex-img ${isAnimated ? "animated" : ""
              }`}
            style={{ animationDelay: "5.5s" }}
          />
          <img
            alt="Images"
            src={image12}
            className={`collection-img-flex-img ${isAnimated ? "animated" : ""
              }`}
            style={{ animationDelay: "6s" }}
          />
        </div>
      </div>

      {/* Basket */}
      <div className="collection-body">
        <p className="collection-top-title">Basket</p>
        <div className="collection-img-flex">
          <img
            alt="Images"
            src={image18}
            className={`collection-img-flex-img ${isAnimated ? "animated" : ""
              }`}
            style={{ animationDelay: "4.5s" }}
          />
        </div>
      </div>
    </div>
  );
}
export default LivingLinen;
